import React, { useState } from "react";
import { useField } from "formik";
import { FormField } from "semantic-ui-react";
import eyeShow from "../../../assets/icons/eye-show.svg";
import eyeHide from "../../../assets/icons/eye-hide.svg";

export default function MyPasswordInput({
  label,
  labelText,
  containerStyle,
  errorClasses = "error-message",
  passwordVisible = false,
  ...props
}) {
  const [field, meta] = useField(props);

  const [showPassword, setShowPassword] = useState(passwordVisible);

  const eye = (
    <img
      className="clickable"
      onClick={() => setShowPassword(!showPassword)}
      style={{
        width: 23,
        height: 23,
        position: "absolute",
        top: "25%",
        right: "3%",
        zIndex: 20,
      }}
      src={showPassword ? eyeHide : eyeShow}
      alt="eye icon"
    />
  );

  return (
    <div style={containerStyle}>
      <FormField
        style={{ marginTop: 10, marginBottom: 10 }}
        error={meta.touched && !!meta.error}
      >
        <label>{label}</label>
        <div style={{ marginBottom: 8 }}>{labelText}</div>
        <div style={{ position: "relative", display: "flex" }}>
          <input
            className="form-input-field"
            type={showPassword ? "text" : "password"}
            {...field}
            {...props}
            style={{ paddingRight: 50 }}
          />
          {eye}
        </div>
        {meta.touched && meta.error ? (
          <div style={{ position: "absolute" }} className={errorClasses}>
            {meta.error}
          </div>
        ) : null}
      </FormField>
    </div>
  );
}
